@if (!isLoading) {
	<div [attr.aria-description]="'file Viewer'" class="d-flex" [class.flex-column-reverse]="currentViewType !== viewType.Desktop">
		<div class="d-flex align-items-center justify-content-center position-relative img-container">
			@if (attachment?.defaultImageUrl) {
				<div class="file-icon">
					<img
						class="with-default-img"
						loading="lazy"
						width="171"
						style="height: 100%; min-height: 100px"
						[alt]="attachment?.title"
						src="{{ attachment.thumbnailUrl }}" />
				</div>
			}
			@if (!attachment?.defaultImageUrl) {
				<div class="file-icon">
					<img [alt]="attachment?.title" loading="lazy" width="91" height="91" src="{{ attachment.thumbnailUrl }}" />
				</div>
			}
			@if (attachment?.defaultImageUrl) {
				<div>
					<div class="position-absolute triangle-bottomright"></div>
					<img class="position-absolute triangle-logo" alt="File Logo" [src]="attachment?.defaultImageUrl" />
				</div>
			}
		</div>
		@if (showButton) {
			<div [ngClass]="currentViewType === viewType.Desktop ? 'mx-4' : 'mb-2'" class="h-auto">
				@if (!contentRef.innerHTML.trim()) {
					<lib-button (clicked)="showViewerClick()" [width]="13">
						{{ 'catalog-view.showInViewer' | translate }}
					</lib-button>
				}
				<div #contentRef>
					<ng-content></ng-content>
				</div>
			</div>
		}
	</div>
}
@if (showLoading && isLoading) {
	<div class="h-100">
		<lib-loading></lib-loading>
	</div>
}
